import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        width: "95%",
        background: theme.palette.primary.main,
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15)",
        borderRadius: "4px",
        margin: "0 auto",
        marginTop: "20px",
    },
    detailsContainer: {
        display: "flex",
        flexDirection: "column",
        background: theme.palette.primary.main,
        gap: theme.spacing(6),
        alignItems: "center",
        padding: "25px 0",
        margin: "0 25px",
    },
    textContainer: {
        width: "100%",
    },
    textContainerSeparator: {
        borderTop: `1px solid ${theme.palette.corporateBO.lineSeparator}`,
        paddingTop: "20px",
        width: "100%",
    },
    gridContainerSeparator: {
        "&.MuiGrid-root": {
            borderTop: `1px solid ${theme.palette.corporateBO.lineSeparator}`,
            paddingTop: "20px",
        },
    },
    label: {
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            textAlign: "left",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
    },
    text: {
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            textAlign: "left",
            fontWeight: 400,
            fontSize: "14px",
            color: theme.palette.text.secondary,
        },
    },
    switch: {
        "&.MuiSwitch-root .MuiButtonBase-root .MuiSwitch-thumb": {
            background: theme.palette.primary.dark,
        },
        "&.MuiSwitch-root .Mui-checked .MuiSwitch-thumb": {
            background: theme.palette.info.main,
        },
        "&.MuiSwitch-root .MuiSwitch-track": {
            background: theme.palette.corporateBO.checkboxTrack,
        },
        "&.MuiSwitch-root .Mui-checked+ .MuiSwitch-track": {
            background: theme.palette.corporateBO.checkboxTrackChecked,
        },
    },
    select: {
        "&.MuiInputBase-root .MuiSelect-select": {
            padding: 0,
            fontFamily: "Open Sans",
            whiteSpace: "normal",
            fontWeight: 400,
            fontSize: "14px",
            color: theme.palette.text.secondary,
        },
    },
    menuItem: {
        "&.MuiButtonBase-root": {
            fontFamily: "Open Sans",
            fontWeight: 400,
            fontSize: "14px",
            color: theme.palette.text.secondary,
        },
    },
    gridBorderTop: {
        borderTop: `1px solid ${theme.palette.corporateBO.lineSeparator}`,
    },
    gridItemStyle: {
        "&.MuiGrid-root.MuiGrid-item ": {
            paddingTop: "15px",
        },
        display: "flex",
        justifyContent: "flex-start",
    },
    refreshIcon: {
        color: theme.palette.info.main,
    },
    loadingContainer: {
        padding: "8px",
    },
    switchLabel: {
        "&.MuiFormControlLabel-root": {
            paddingTop: "15px",
            width: "100%",
            justifyContent: "flex-end",
            margin: 0,
        },
        "&.MuiFormControlLabel-root .MuiTypography-root": {
            fontFamily: "Open Sans",
            fontWeight: 400,
            fontSize: "14px",
            color: theme.palette.text.secondary,
        },
    },
    buttonsContainer: {
        width: "100%",
        borderTop: `1px solid ${theme.palette.corporateBO.lineSeparator}`,
        padding: "15px 30px",
        display: "flex",
        justifyContent: "flex-end",
    },
    addButton: {
        "&.MuiButton-root": {
            background: theme.palette.info.main,
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            color: theme.palette.primary.main,
            marginLeft: "15px",
        },
        "&.MuiButton-root:hover": {
            background: theme.palette.info.main,
        },
    },
    cancelButton: {
        "&.MuiButtonBase-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            color: theme.palette.primary.dark,
        },
    },
    modalContentContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: theme.spacing(6),
        padding: "20px 30px 0",
    },
    modalText: {
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            textAlign: "left",
            fontWeight: 500,
            fontSize: "14px",
            color: theme.palette.text.secondary,
            width: "100%",
        },
    },
    refreshButton: {
        "&.Mui-disabled:disabled": {
            "& > svg": {
                color: theme.palette.primary.dark,
            },
        },
    },
}));
